import { Household, HouseholdProperty, Property } from '@/icons'
import type { BoxProps} from '@chakra-ui/react'
import { Box, Grid } from '@chakra-ui/react'

export interface OfferHeaderColumnWrapperProps extends BoxProps {
  isScrolled?: boolean
  icon?: string
}

export interface IGetRadioIcon {
  icon: string
  colorScheme?: string
  defaultIconSize?: string
}

export const getRadioIcon = ({ icon, colorScheme, defaultIconSize = '28px' }: IGetRadioIcon) => {
  const defaultIconProps = {
    color: 'primary.800',
    width: defaultIconSize,
    height: defaultIconSize,
  }

  switch (icon) {
    case 'householdProperty':
      return <HouseholdProperty {...defaultIconProps} width="70px" />
    case 'household':
      return <Household {...defaultIconProps} />
    case 'property':
      return <Property {...defaultIconProps} />
  }
}

export const OfferHeaderColumnWrapper = ({
  children,
  isScrolled,
  sx,
  icon,
  ...rest
}: OfferHeaderColumnWrapperProps) => {
  const iconSize = '12'

  return (
    <Grid
      sx={{
        position: 'sticky',
        left: 0,
        alignItems: 'end',
        alignContent: 'stretch',
        bg: 'gray.50',
        boxShadow: isScrolled ? 'xl' : 'none',
        zIndex: 100,
        // _after: {
        //   w: '1px',
        //   h: '100%',
        //   content: "''",
        //   position: 'absolute',
        //   top: 0,
        //   bottom: 0,
        //   left: '100%',
        //   bgColor: 'gray.300',
        // },
      }}
      {...rest}
    >
      <Box
        sx={{
          display: 'grid',
          pb: 8,
          justifyContent: 'center',
          alignContent: 'end',
          alignItems: 'end',
          height: '100%',
          width: '100%',
          bg: 'gray.50',
          zIndex: 100,
        }}
      >
        <Box sx={{ mt: 3, ml: -1 }}>
          {icon && getRadioIcon({ colorScheme: 'primary', icon, defaultIconSize: iconSize })}
        </Box>
      </Box>

      {children}
    </Grid>
  )
}
